
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { isAdmin as checkIsAdmin } from "@/services/authService";
import AdminLayout from "@/components/admin/AdminLayout";
import PostEditor from "@/components/admin/PostEditor";
import { usePostEditor } from "@/hooks/usePostEditor";

const NewPost = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const {
    title,
    slug,
    excerpt,
    content,
    author,
    seoDescription,
    theme,
    categories,
    featuredImage,
    featuredImageAlt,
    featuredImageTitle,
    isDraft,
    isPending,
    setTitle,
    setSlug,
    setExcerpt,
    setContent,
    setAuthor,
    setSeoDescription,
    setTheme,
    setCategories,
    setFeaturedImage,
    setFeaturedImageAlt,
    setFeaturedImageTitle,
    togglePublishStatus,
    handleImageUpload,
    handleSaveAsDraft,
    handleSubmit,
  } = usePostEditor();

  // Check if the user is logged in
  useEffect(() => {
    const checkSession = async () => {
      const isAdmin = await checkIsAdmin();
      if (!isAdmin) {
        toast({
          title: "Access denied",
          description: "Please login to create blog posts",
          variant: "destructive",
        });
        
        navigate("/admin/login");
      }
    };
    
    checkSession();
  }, [navigate, toast]);

  return (
    <AdminLayout title="Create New Blog Post" backLink="/admin/dashboard" backLabel="Back to Dashboard">
      <PostEditor
        title={title}
        setTitle={setTitle}
        slug={slug}
        setSlug={setSlug}
        excerpt={excerpt}
        setExcerpt={setExcerpt}
        author={author}
        setAuthor={setAuthor}
        seoDescription={seoDescription}
        setSeoDescription={setSeoDescription}
        theme={theme}
        setTheme={setTheme}
        categories={categories}
        setCategories={setCategories}
        content={content}
        setContent={setContent}
        featuredImage={featuredImage}
        setFeaturedImage={setFeaturedImage}
        featuredImageAlt={featuredImageAlt}
        setFeaturedImageAlt={setFeaturedImageAlt}
        featuredImageTitle={featuredImageTitle}
        setFeaturedImageTitle={setFeaturedImageTitle}
        isDraft={isDraft}
        isPending={isPending}
        showDeleteDialog={false}
        setShowDeleteDialog={() => {}}
        togglePublishStatus={togglePublishStatus}
        handleSubmit={handleSubmit}
        handleDeletePost={async () => {}}
        onFileUpload={handleImageUpload}
      />
    </AdminLayout>
  );
};

export default NewPost;
